module.exports = __webpack_public_path__ + "img/crusher.0946bc90.png";